import { createFileRoute, Outlet } from "@tanstack/react-router"
import { AllBudgetsProvider } from "~/context/AllBudgetsProvider"
import { useCompany } from "~/hooks/useCompany"
import LoadingOverlay from "~/components/reusable/LoadingOverlay"

export const Route = createFileRoute("/_auth/budgets/_layout")({
  component: RouteComponent,
})

function RouteComponent() {
  // Budget year math reads the company's fiscal calendar from the fiscal-config store, which
  // holds it only once the company has loaded.
  const { data: company } = useCompany()
  if (!company) return <LoadingOverlay />
  return (
    <AllBudgetsProvider>
      <Outlet />
    </AllBudgetsProvider>
  )
}
